<template>
  <div class="empty">
      <i class="iconfont iconzanwudingdan"></i>
      <div>{{title}}</div>
  </div>
</template>

<script>
  export default {
    name: 'headerNav', /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    props: ['title'],
    data() {
      return {
        octopus: this.$parent.octopus,
      }
    },
    methods: {}
  }

</script>



// WEBPACK FOOTER //
// src/components/Engine/FrameworkAPPLET/Empty.vue